export default [
    {
        path: "/shortvideo/douyin/post/detail",
        name: "shortvideo-douyin-post-detail",
        component: () => import("@/views/shortvideo/douyin/post/detail.vue"),
    },
    {
        path: "/shortvideo/douyin/user/view",
        name: "shortvideo-douyin-user-view",
        component: () => import("@/views/shortvideo/douyin/user/view.vue"),
    },
    {
        path: "/shortvideo/tiktok/post/detail",
        name: "shortvideo-tiktok-post-detail",
        component: () => import("@/views/shortvideo/tiktok/post/detail.vue"),
    },
    {
        path: "/shortvideo/xhs/post/detail",
        name: "shortvideo-xhs-post-detail",
        component: () => import("@/views/shortvideo/xhs/post/detail.vue"),
    },
]